<template>
  <div id="app">
    <div v-show="$store.state.connected && $store.state.loaded" id="nav">
      <div id="banner">
        <router-link id="logo" to="/"
          ><img src="./assets/aprogsys.png"
        /></router-link>
        <span class="links" v-show="$store.state.connected">
          <router-link to="/deconnexion">Déconnexion</router-link>
          <router-link to="/aide">Aide</router-link>
          <router-link to="/compte">Mon compte</router-link>
          <router-link to="/conges">Les congés</router-link>
          <router-link
            v-show="$store.state.userRole === 324 || $store.state.userRole === 68"
            to="/holidays"
            >Jours fériés</router-link
          >
          <router-link
            v-show="$store.state.userRole === 324 || $store.state.userRole === 68"
            to="/rapport"
            >Rapport</router-link
          >
          <router-link
            v-show="$store.state.userRole === 324 || $store.state.userRole === 68"
            to="/advance"
            >Avancement</router-link
          >
          <router-link
            v-show="$store.state.userRole === 324 || $store.state.userRole === 68"
            to="/utilisateurs"
            >Utilisateurs</router-link
          >
          <router-link
            v-show="$store.state.userRole === 324 || $store.state.userRole === 68"
            to="/projets"
            >Projets</router-link
          >
          <router-link to="/dashboard">Mes saisies</router-link>
          <router-link to="/">Accueil</router-link>
        </span>
      </div>
    </div>
    <router-view  v-show="$store.state.loaded"/>
    <div v-show="$store.state.connected && $store.state.loaded" id="footer"></div>
    <div class="loader" v-show="!$store.state.loaded">
      <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Help",
  data() {
    return {};
  },
  created: function () {
    this.$store.commit("created");
  },
};
</script>

<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

#footer {
  height: 0.5em;
  width: 100%;
  background-color: #fec053;
  position: fixed;
  bottom: 0;
}

#banner {
  height: 4.5em;
  padding: 0.1em;
  display: inline-block;
  width: 100%;
  background-color: #fec053;
}

.links {
  float: right;
  max-width: 600px;
  display: contents;
}

#logo {
  float: left !important;
}
img {
  height: 2.5em;
}

#appName,
#title {
  margin-left: 8px;
}

#title {
  float: left;
}

#nav {
  height: auto;
}

#banner a {
  font-weight: bold;
  color: #2c3e50;
  float: right;
  padding-right: 0.5em;
}

#banner a.router-link-exact-active {
  color: #42b983;
}
.table {
  overflow: hidden!important;
}

@media screen and (max-width: 800px) {
  #banner {
    height: 8em;
  }
  .links {
    display: flow-root;
  }
}

@media screen and (max-width: 480px) {
  #banner {
    height: 10em;
  }
  .links {
    display: flow-root;
  }
}

@media screen and (max-width: 630px) {
  #banner {
    height: 12em!important;
    display: flex!important;
    flex-direction: column!important;
  }
  .links {
    display: flow-root;
    justify-content: center;
    display: flex;
  }
  .navigation {
    left: 57%!important;

  }
  .border {
    width: 73% !important;
  }
  #text {
    left: 39.5%;
  }
}

@media screen and (max-width: 360px) {
  #banner {
    height: 12em;
  }
  .links {
    display: flow-root;
  }
}
.loader {
  margin-top: 40vh;
}
.lds-roller {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-roller div {
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  transform-origin: 40px 40px;
}
.lds-roller div:after {
  content: " ";
  display: block;
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #fec053;
  margin: -4px 0 0 -4px;
}
.lds-roller div:nth-child(1) {
  animation-delay: -0.036s;
}
.lds-roller div:nth-child(1):after {
  top: 63px;
  left: 63px;
}
.lds-roller div:nth-child(2) {
  animation-delay: -0.072s;
}
.lds-roller div:nth-child(2):after {
  top: 68px;
  left: 56px;
}
.lds-roller div:nth-child(3) {
  animation-delay: -0.108s;
}
.lds-roller div:nth-child(3):after {
  top: 71px;
  left: 48px;
}
.lds-roller div:nth-child(4) {
  animation-delay: -0.144s;
}
.lds-roller div:nth-child(4):after {
  top: 72px;
  left: 40px;
}
.lds-roller div:nth-child(5) {
  animation-delay: -0.18s;
}
.lds-roller div:nth-child(5):after {
  top: 71px;
  left: 32px;
}
.lds-roller div:nth-child(6) {
  animation-delay: -0.216s;
}
.lds-roller div:nth-child(6):after {
  top: 68px;
  left: 24px;
}
.lds-roller div:nth-child(7) {
  animation-delay: -0.252s;
}
.lds-roller div:nth-child(7):after {
  top: 63px;
  left: 17px;
}
.lds-roller div:nth-child(8) {
  animation-delay: -0.288s;
}
.lds-roller div:nth-child(8):after {
  top: 56px;
  left: 12px;
}
@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>